import { Layout } from "@/components/Layout";
import { ServiceCard } from "@/components/Cards";
import { services } from "@/data/index";
import { IMAGES } from "@/assets/images";
import { motion } from "framer-motion";
import { springPresets, staggerContainer, staggerItem } from "@/lib/motion";

export default function Services() {
  return (
    <Layout>
      <div className="relative">
        <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
          <div className="hero-background">
            <img
              src={IMAGES.AI_BACKGROUND_7}
              alt="AI Technology Background"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="hero-overlay" />
          
          <div className="relative z-10 container mx-auto px-4 py-24 text-center">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={springPresets.gentle}
            >
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
                AI-Led IT Services
              </h1>
              <p className="text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto">
                Transforming businesses with cutting-edge AI and cloud technology solutions
              </p>
            </motion.div>
          </div>
        </section>

        <section className="py-24 bg-background">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={springPresets.gentle}
              className="text-center mb-16"
            >
              <h2 className="text-4xl md:text-5xl font-bold mb-6">Our Services</h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Comprehensive AI-powered solutions designed to accelerate your digital transformation journey
              </p>
            </motion.div>

            <motion.div
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
            >
              {services.map((service) => (
                <motion.div key={service.id} variants={staggerItem}>
                  <ServiceCard service={service} />
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section>

        <section className="relative py-24 overflow-hidden">
          <div className="absolute inset-0 z-0 opacity-30">
            <img
              src={IMAGES.CLOUD_SERVERS_1}
              alt="Cloud Infrastructure"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-background/50 via-transparent to-background/70" />
          
          <div className="relative z-10 container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={springPresets.gentle}
              className="max-w-4xl mx-auto text-center"
            >
              <h2 className="text-4xl md:text-5xl font-bold mb-8">Why Choose ALTCloud Canada?</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
                <div className="bg-card/80 backdrop-blur-sm p-8 rounded-2xl border border-border shadow-lg">
                  <div className="text-5xl font-bold text-primary mb-4">60+</div>
                  <div className="text-lg font-semibold mb-2">Years Combined Experience</div>
                  <p className="text-muted-foreground">Decades of expertise in technology and business development</p>
                </div>
                <div className="bg-card/80 backdrop-blur-sm p-8 rounded-2xl border border-border shadow-lg">
                  <div className="text-5xl font-bold text-accent mb-4">100%</div>
                  <div className="text-lg font-semibold mb-2">AI-Powered Solutions</div>
                  <p className="text-muted-foreground">Every service enhanced with artificial intelligence</p>
                </div>
                <div className="bg-card/80 backdrop-blur-sm p-8 rounded-2xl border border-border shadow-lg">
                  <div className="text-5xl font-bold text-primary mb-4">24/7</div>
                  <div className="text-lg font-semibold mb-2">Support & Monitoring</div>
                  <p className="text-muted-foreground">Round-the-clock service and infrastructure oversight</p>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        <section className="py-24 bg-muted/30">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={springPresets.gentle}
              className="max-w-3xl mx-auto text-center"
            >
              <h2 className="text-4xl md:text-5xl font-bold mb-6">Ready to Transform Your Business?</h2>
              <p className="text-lg text-muted-foreground mb-8">
                Let's discuss how our AI-led IT services can drive innovation and growth for your organization.
              </p>
              <motion.a
                href="mailto:reach@altcloudai.com"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.97 }}
                transition={springPresets.snappy}
                className="inline-block bg-primary text-primary-foreground px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all"
              >
                Get Started Today
              </motion.a>
            </motion.div>
          </div>
        </section>
      </div>
    </Layout>
  );
}
